import { Component, inject } from '@angular/core';
import { EpTableComponent, EPTableConfig } from '@ep/shared';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { MerchantRepresentativeAccess } from '@shared/models';
import { MerchantsApiService } from '@app/areas/merchants/services/merchants.api.service';

@Component({
  selector: 'app-access-table',
  templateUrl: './access-table.component.html',
  styleUrls: ['./access-table.component.scss'],
  standalone: true,
  imports: [EpTableComponent, AsyncPipe],
})
export class AccessTableComponent {
  private readonly merchantsApiService = inject(MerchantsApiService);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);

  protected config: EPTableConfig<MerchantRepresentativeAccess> = {
    header: 'access',
    pagination: {
      rows: 10,
      showCurrentPageReport: true,
    },
    columns: [
      {
        header: 'Representative',
        field: 'RepresentativeName',
        columnType: 'string',
        defaultValue: '',
      },
      {
        header: 'Email',
        field: 'EmailAddress',
        columnType: 'string',
        defaultValue: '',
      },
    ],
    style: {
      'min-width': '50rem',
      border: '5px',
    },
    globalFilterFields: ['RepresentativeName', 'EmailAddress'],
    actions: {
      rowClick: (access: MerchantRepresentativeAccess) => {
        this.router.navigate([access.RepresentativeId], { relativeTo: this.route });
      },
    },
  };

  protected access$: Observable<MerchantRepresentativeAccess[]> = this.route.parent!.parent!.paramMap.pipe(
    map((params) => Number(params.get('merchantId'))),
    switchMap((merchantId) => this.merchantsApiService.getAccessByMerchantId(merchantId))
  );
}
